<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">Manage Administrators</h3>
        </div>
        <div class="col-auto float-right ml-auto">
          <button class="btn add-btn" @click="add">
            <i class="fa fa-plus"></i>New Administrator
          </button>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Table List -->
    <div class="row">
      <div class="col-md-12">
        <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1">
          <form id="saveForm" @submit.prevent="save"></form>
          <table class="table table-bordered custom-table mb-0">
            <thead class="thead-light">
              <tr>
                <th class="action-column">Action</th>
                <th>Login Name</th>
                <th>Full Name</th>
                <th>Email</th>
                <th>Companies</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="showAddMode" class="table-info">
                <td class="action-column">
                  <button type="submit" class="btn" title="Save" form="saveForm">
                    <i class="fa fa-save"></i>
                  </button>
                  <button type="button" class="btn" title="Cancel" @click="cancel">
                    <i class="fa fa-window-close-o"></i>
                  </button>
                </td>
                <td>
                  <input type="text" class="form-control" v-model="formData.loginName" maxlength="50" form="saveForm"
                    required />
                </td>
                <td>
                  <input type="text" class="form-control" v-model="formData.name" maxlength="100" form="saveForm" />
                </td>
                <td>
                  <input type="email" class="form-control" v-model="formData.email" maxlength="100" form="saveForm" />
                </td>
                <td>
                  <div class="company-container" v-for="(company, i) in companies" :key="'newCompany' + i">
                    <input :id="'newcompany' + i" type="checkbox" v-model="formData.companies"
                      :value="company.CompanyName" />
                    <label :for="'newcompany' + i">{{ company.CompanyName }}</label>
                  </div>
                </td>
              </tr>
              <tr v-for="item in users" :key="item.Id" :class="!item.IsActive ? 'disabled-color' : ''">
                <template v-if="formData.id !== item.Id">
                  <td class="action-column">
                    <label class="toggler">
                      <input type="checkbox" v-model="item.IsActive" @change="toggle(item, $event)" />
                      <span class="slider round"></span>
                    </label>
                    <button v-if="item.IsActive" class="btn mt-2" title="Edit" @click="edit(item)">
                      <i class="fa fa-edit"></i>
                    </button>
                    <button v-if="item.IsActive" class="btn mt-2" title="Delete" @click="remove(item.Id)">
                      <i class="fa fa-trash-o"></i>
                    </button>
                  </td>
                  <td>{{ item.LoginName }}</td>
                  <td>{{ item.Name }}</td>
                  <td>{{ item.Email }}</td>
                  <td>
                    <div class="company-container" v-for="(company, i) in companies" :key="i + company.CompanyName">
                      <input disabled type="checkbox" :value="company.CompanyName" v-model="item.Companies" />
                      <label style="cursor:inherit">{{ company.CompanyName }}</label>
                    </div>
                  </td>
                </template>
                <template v-else>
                  <td class="action-column table-info">
                    <button type="submit" class="btn" title="Save" form="saveForm">
                      <i class="fa fa-save"></i>
                    </button>
                    <button type="button" class="btn" title="Cancel" @click="cancel">
                      <i class="fa fa-window-close-o"></i>
                    </button>
                  </td>
                  <td class="table-info">
                    <input type="text" class="form-control" v-model="formData.loginName" maxlength="50" form="saveForm"
                      required />
                  </td>
                  <td class="table-info">
                    <input type="text" class="form-control" v-model="formData.name" maxlength="100" form="saveForm" />
                  </td>
                  <td class="table-info">
                    <input type="email" class="form-control" v-model="formData.email" maxlength="100" form="saveForm" />
                  </td>
                  <td class="table-info">
                    <div class="company-container" v-for="(company, i) in companies" :key="'editCompany' + i">
                      <input :id="'editCompany' + i" type="checkbox" v-model="formData.companies"
                        :value="company.CompanyName" />
                      <label :for="'editCompany' + i">{{ company.CompanyName }}</label>
                    </div>
                  </td>
                </template>
              </tr>
              <tr v-if="users && !users.length">
                <td colspan="5" class="text-center">{{ this.noRecordText }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- /Table List -->
  </div>
</template>

<script>
import API from "../../http-common.js";
import config from "../../config.js";

export default {
  data() {
    return {
      users: null,
      showAddMode: false,
      noRecordText: config.NO_RECORD_TEXT,
      formData: {
        id: "",
        loginName: "",
        name: "",
        email: "",
        companies: []
      },
      companies: []
    };
  },

  computed: {
    token() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Token;
    },
    role() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Role;
    },
  },

  methods: {
    getAdministrators() {
      let param = {
        Token: this.token,
      };
      this.$store.state.isLoading = true;
      API.getAdministrators(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.users = response.data.record;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },

    //action
    resetForm() {
      this.formData = {
        id: "",
        loginName: "",
        name: "",
        email: "",
        companies: []
      };
    },
    add() {
      this.showAddMode = true;
      this.resetForm();
    },
    edit(payload) {
      this.showAddMode = false;
      this.resetForm();
      this.formData.id = payload.Id;
      this.formData.loginName = payload.LoginName;
      this.formData.name = payload.Name;
      this.formData.email = payload.Email;
      this.formData.companies = payload.Companies || [];
    },
    cancel() {
      this.showAddMode = false;
      this.resetForm();
      this.getAdministrators();
    },
    remove(id) {
      let param = {
        Token: this.token,
        Id: id,
      };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to delete the record?",
        icon: "info",
        buttons: true,
        dangerMode: false,
      }).then((willDelete) => {
        if (willDelete) {
          this.$store.state.isLoading = true;
          API.deleteAdministrator(param)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              if (response.data.success) {
                this.cancel();
              }
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              this.$swal(error.response.data.Message, { icon: "error" });
            });
        }
      });
    },

    save() {
      let param = {
        Token: this.token,
        Id: this.formData.id,
        LoginName: this.formData.loginName,
        Name: this.formData.name,
        Email: this.formData.email,
        Companies: this.formData.companies
      };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to save the record?",
        icon: "info",
        buttons: true,
        dangerMode: false,
      }).then((willSave) => {
        if (willSave) {
          this.$store.state.isLoading = true;
          API.saveAdministrator(param)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              if (response.data.success) {
                this.cancel();
              }
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              this.$swal(error.response.data.Message, { icon: "error" });
            });
        }
      });
    },

    toggle(payload, $event) {
      let isActive = $event.target.checked;
      let param = {
        Token: this.token,
        Id: payload.Id,
        IsActive: isActive,
      };
      this.$store.state.isLoading = true;
      API.toggleAdministrator(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          this.$swal(response.data.message, {
            icon: response.data.success ? "success" : "error",
          });
          if (response.data.success) {
            this.cancel();
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getCompanies() {
      this.$store.state.isLoading = true;
      API.getCompanies({ Token: this.token })
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.companies = response.data.record;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
  },

  created() {
    if (this.role != "admin") this.$router.replace({ name: "home" });
    this.getCompanies();
    this.getAdministrators();
  },
};
</script>

<style scoped>
.company-container {
  display: flex;
  align-items: center;
  gap: 5px;
}

td label,
td input[type='checkbox'] {
  cursor: pointer;
}

td label {
  margin-bottom: -0.1rem;
}

/* input[type='checkbox'].disabled {
  accent-color: lightgray;
  pointer-events: none;
  cursor: not-allowed;
} */

input[type='checkbox']:disabled {
  pointer-events: none;
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/components/Account/Administrators.vue